import api from './api';
import { trackPromise } from 'react-promise-tracker';
import { getJwt } from '@app/helpers';
import Axios from 'axios';

export interface PrevisaoPagamentoFilter {
  dataInicial: string;
  dataFinal: string;
  tipoDeDocumentoIds: string;
  analistaGPCIds: string;
  numeroContrato: string;
  codigoFornecedor: string;
  numeroDocumento: string;
}

export interface RelatorioPrevisoesPgto {
  tipoDocumentoCobranca: string;
  numeroDocumentoCobranca: string;
  numeroParcela: string;
  dataEmissaoDocumentoCobranca: string;
  numeroFornecedor: string;
  fornecedor: string;
  numeroContrato: string;
  numeroBm: string;
  analistaGPC?: string;
  area?: string;
  dataPrevisaoPagamento: string;
  valorParcela: number;
}

export const searchValues = (values: PrevisaoPagamentoFilter) => {
  return api.post<RelatorioPrevisoesPgto[]>('relatorios/previsaopagamento', values, {
    disableNotification: 'true',
  });
};

// export const exportExcel = (values: PrevisaoPagamentoFilter) =>
//   api.downloadFile('relatorio/previsaoPgto/excel', 'relatorioPrevisaoPgto.xls', values);


export const relatorioExportExcel = (values: PrevisaoPagamentoFilter) => {

  let urlBase = window.location.origin;
  trackPromise(Axios.post(urlBase + `/api/relatorios/previsaopagamento/excel`, values,
    {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "relatorio_previsaopagamento.xlsx");
      link.setAttribute('id', 'downloadrelatorio_previsaopagamento');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadrelatorio_previsaopagamento').outerHTML = '';
    }));
};